export const IconDashboard = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24px"
			height="24px"
			viewBox="0 -960 960 960"
			fill="#1f1f1f">
			<path d="M424.15-346.15q21.31 21.3 54.89 20.23 33.57-1.08 49.27-24.23l161.33-233.69q8.59-12.93-1.95-23.47-10.54-10.53-23.49-1.96L430.15-448.31q-23.53 15.7-25.42 48.27-1.88 32.58 19.42 53.89ZM480-780q39.46 0 75.42 7.16 35.97 7.15 70.12 22.07 12.15 4.85 24.19 17.31 12.04 12.46 6.15 23.61-5.88 11.16-25.42 14.81-19.54 3.66-32.3-1.19-28.08-12.08-57.24-17.92Q511.77-720 480-720q-133 0-226.5 93.5T160-400q0 42 11.5 83t32.5 77h552q23-38 33.5-79t10.5-85q0-28.31-5.65-58.12-5.66-29.8-17.74-57.27-4.84-12.76-2-24.92 2.85-12.15 13.46-20.13 9.85-7.25 21.51-4.02 11.65 3.23 16.5 14.15 17.3 37.69 25.3 74.19t8.62 74.89q.61 54.31-12.23 102.65-12.85 48.35-38.69 94.58-7.93 13-22.31 20.5Q772.38-180 756-180H204q-16 0-30.19-7.69-14.19-7.7-22.89-21.85-22.92-40-36.92-87.23Q100-344 100-400q0-78.38 29.74-147.37 29.74-68.99 81.19-120.85 51.46-51.86 120.99-81.82Q401.46-780 480-780Zm4.31 295.69Z" />
		</svg>
	);
};
